import { useCallback, useEffect, useState } from 'react';

import {
  playerFields as fetchSelectedCountryState,
  type PlayerFields,
} from '@/api/common';
import type { Country } from '@/helpers/conf';
import { REGIONS_BY_COUNTRY } from '@/helpers/regions';
import { useGetCommonStore } from '@/store';

export const useCountryState = (selectedCountry: string) => {
  const useCommonStore = useGetCommonStore();

  const userState = useCommonStore.use.user()?.state;
  const [statesPending, setStatesPending] = useState(!userState);
  const [states, setStates] = useState<PlayerFields | null>(null);

  const regionCode = useCommonStore.use.regionCode();

  const defaultState =
    REGIONS_BY_COUNTRY[selectedCountry as Country]?.[regionCode] ?? '';

  const fetchStateData = useCallback(async () => {
    try {
      setStatesPending(true);
      const { data } = await fetchSelectedCountryState(selectedCountry);
      setStates(data || null);
    } catch (error) {
      console.log(error);
    } finally {
      setStatesPending(false);
    }
  }, [selectedCountry]);

  useEffect(() => {
    if (!userState) {
      fetchStateData();
    }
  }, [fetchStateData, userState]);

  return { statesPending, states, defaultState };
};
